import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import SlideList from './SlideList';
import s from './Carousel.css';

class Carousel extends React.Component {
  static propTypes = {
    step: PropTypes.number,
    itemsInRow: PropTypes.number,
    itemsPosition: PropTypes.string,
    header: PropTypes.node,
    items: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
    classNames: PropTypes.shape(),
    loop: PropTypes.bool,
  };

  static defaultProps = {
    step: 1,
    itemsInRow: 1,
    itemsPosition: 'body',
    header: '',
    items: [],
    classNames: {},
    loop: false,
  };

  state = {
    index: 0,
    slidesInfo: [],
  };

  componentDidMount() {
    const slidesInfo = this.getChildrenArray(this.carousel).map(slide => ({
      fullWidth: this.getFullWidth(slide),
    }));

    this.setSlidesInfo(slidesInfo);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.items !== nextProps.items) {
      this.setState({ index: 0 });
    }

  }

  getChildrenArray = item => {
    if (!item.children || item.children.length === 0) {
      return [];
    } else if (item.children.length === 1) {
      return this.getChildrenArray(item.children[0]);
    }

    return [...item.children];
  };

  getFullWidth = elem => {
    const { marginLeft, marginRight } = getComputedStyle(elem);

    return [elem.offsetWidth, marginLeft, marginRight]
      .map(i => parseFloat(i))
      .reduce((result, current) => result + current, 0);
  };

  getSlidesWidth = arr => arr.reduce((width, slide) => width + slide.fullWidth, 0);

  setSlidesInfo = slidesInfo => {
    this.setState({ slidesInfo });
  };

  handleNextClick = () => {
    const { step, loop, itemsInRow, items: { length: slideCount } } = this.props;

    this.setState(({ index }) => {
      const nextIndex = index + step > slideCount ? slideCount : index + step;
      return {
        index: loop && index >= slideCount - itemsInRow ? 0 : nextIndex,
      };
    });
  };

  handlePrevClick = () => {
    const { step, loop, itemsInRow, items: { length: slideCount } } = this.props;

    this.setState(({ index }) => {
      const nextIndex = index - step < 0 ? 0 : index - step;
      return {
        index: loop && index === 0 ? slideCount - itemsInRow : nextIndex,
      };
    });
  };

  render() {
    const { index, slidesInfo } = this.state;
    const {
      loop,
      items,
      itemsInRow,
      itemsPosition,
      header,
      classNames: { main: mainCN = '', header: headerCN = '', body: bodyCN, slider: sliderCN = '' },
    } = this.props;

    const maxLeft =
      this.carousel && this.getSlidesWidth(slidesInfo) - this.carousel.parentNode.offsetWidth;
    const left = this.getSlidesWidth(slidesInfo.slice(0, index));
    const marginLeft = Math.min(maxLeft, left);
    const roundMarginLeft = maxLeft - marginLeft < 20 ? maxLeft : marginLeft;

    return (
      <div className={mainCN || s.carousel}>
        <div className={cx(headerCN && headerCN, s.carouselHeader)}>
          {header}
          <div className={s.carouselHeaderContent}>
            {itemsPosition === 'header' &&
              <SlideList
                items={items}
                marginLeft={roundMarginLeft}
                containerCN={s.carouselContainer}
                sliderCN={s.carouselSlider}
                inputRef={item => {
                  this.carousel = item;
                }}
              />}
          </div>

          {itemsInRow < items.length &&
            <div className={s.carouselNav}>
              <div
                className={cx(s.carouselNavButton, { [s.disabled]: marginLeft === 0 && !loop })}
                onClick={marginLeft > 0 || loop ? this.handlePrevClick : null}
              >
                <i className={`fa fa-angle-left ${s.icon}`} />
              </div>
              <div
                className={cx(s.carouselNavButton, {
                  [s.disabled]: marginLeft >= maxLeft && !loop,
                })}
                onClick={marginLeft < maxLeft || loop ? this.handleNextClick : null}
              >
                <i className={`fa fa-angle-right ${s.icon}`} />
              </div>
            </div>}
        </div>

        <div className={bodyCN || s.carouselBody}>
          {itemsPosition === 'body' &&
            <SlideList
              items={items}
              marginLeft={marginLeft}
              containerCN={s.carouselContainer}
              sliderCN={cx(sliderCN && sliderCN, s.carouselSlider)}
              inputRef={item => {
                this.carousel = item;
              }}
            />}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Carousel);



// WEBPACK FOOTER //
// ./src/desktop/components/Carousel/Carousel.js